import { useEffect, useState } from "react";

/**
 * `Date.now()`, re-read every `intervalMs` while `active`. Drives the live
 * tick of running sessions and the punch header without re-rendering idle
 * screens: when nothing is running, no timer exists.
 */
export function useNow(intervalMs = 30_000, active = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs, active]);
  return now;
}
